(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collapsable-media"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.btn--colapsable').forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('data-target'));
            const isExpanded = this.getAttribute('aria-expanded') === 'true';

            // Use Bootstrap's built-in toggle method
            const bsCollapse = new bootstrap.Collapse(target, {
                toggle: !isExpanded // Ensures independent toggle behavior
            });

            // Update aria-expanded attribute
            this.setAttribute('aria-expanded', !isExpanded);
        });
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-collapsable"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Initialize all collapse elements
    var collapseElements = document.querySelectorAll('.collapse');
    collapseElements.forEach(function (collapse) {
      new bootstrap.Collapse(collapse, {
        toggle: false,
      });
    });

    // Add click handlers for mobile
    var buttons = document.querySelectorAll('.btn--colapsable');
    buttons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var target = this.getAttribute('data-bs-target');
        var collapse = document.querySelector(target);
        bootstrap.Collapse.getInstance(collapse).toggle();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prenatal-article"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth <= 768) {
      // console.log('You are on a mobile device.');
      document.getElementById('mobile-banner').style.display = 'block';
      document.getElementById('desktop-banner').style.display = 'none';
    } else {
      // console.log('You are on a desktop device.');
      document.getElementById('desktop-banner').style.display = 'block';
      document.getElementById('mobile-banner').style.display = 'none';
    }
  });

  } catch(e) { console.error(e); }
})();
})();
